module.exports = __webpack_public_path__ + "img/20180414165909.8eee3edf.jpg";